<template>
  <div class="official-detail">
    <div class="title pr">
      <div class="name-left">
        <span v-if="detail.Icon"><img :src="imgUrl+ detail.Icon"></span>
        <span v-else>{{xy.showName(detail.FullName)}}</span>
      </div>
      <div class="name-right">
        <div v-cloak>{{detail.FullName}}</div>
        <div class="status"
             v-cloak>{{detail.StatusDescible}}</div>
      </div>
      <!-- 公文归档明细不展示审批状态 -->
      <div v-if="detailType !== 'file'"
           class="officeStatus pa">
        <!--0未审批、1审批中、2已通过、3已拒绝、4已收回-->
        <img v-if="detail.Status === 2"
             class="no-data-img"
             src="@/assets/common/approvalStatus/adopt.png" />
        <img v-else-if="detail.Status === 3"
             class="no-data-img"
             src="@/assets/common/approvalStatus/refuse.png" />
        <img v-else-if="detail.Status === 4"
             class="no-data-img"
             src="@/assets/common/approvalStatus/takeBack.png" />
      </div>
    </div>
    <div class="items">
      <div class="item">
        <div class="left">主题</div>
        <div class="right"
             v-cloak>{{detail.OfficialDocTheme}}</div>
      </div>
      <div class="item">
        <div class="left">公文标题</div>
        <div class="right"
             v-cloak>{{detail.OfficialDocTitle}}</div>
      </div>
      <div class="item">
        <div class="left">公文种类</div>
        <div class="right"
             v-cloak>{{detail.OfficialDocTypeName}}</div>
      </div>
      <div class="item">
        <div class="left">秘密等级</div>
        <div class="right"
             v-cloak>{{detail.OfficialDocSecretLevelName}}</div>
      </div>
      <div class="item">
        <div class="left">紧急程度</div>
        <div class="right"
             v-cloak>{{detail.OfficialDocEmergencyLevelName}}</div>
      </div>
      <div class="item">
        <div class="left">发文机关</div>
        <div class="right"
             v-cloak>{{detail.FromOffice}}</div>
      </div>
      <div class="item">
        <div class="left">发文字号</div>
        <div class="right"
             v-cloak>{{detail.IssueNumber}}</div>
      </div>
      <div class="item">
        <div class="left">发文内容</div>
        <div class="right">
          <div class="office-info"
               v-for="item in detail.List"
               :key="item.OfficialDocAttachmentID">
            <span v-cloak>{{item.FileName}}</span>
            <!--暂不展示下载-->
            <!--<a href="javascript:;" @click="downLoad(item)" style="margin:0.1rem; color:#4196ff;">下载</a>-->
          </div>
        </div>
      </div>
      <div class="item">
        <div class="left">附注</div>
        <div class="right"
             v-cloak>{{detail.Remark}}</div>
      </div>
      <!--已归档时显示展示归档日期-->
      <div class="item"
           v-if="detail.IsArchive">
        <div class="left">归档日期</div>
        <div class="right"
             v-cloak>{{new Date(detail.LastModifyByStrDate.replace(/-/g, '/')).pattern('yyyy-MM-dd  HH:mm')}}</div>
      </div>
    </div>
    <!-- 审批流展示 -->
    <div class="proval-process">
      <div class="left">审批流程</div>
      <approval-flow :dataList="detail.ApprovalFlow"></approval-flow>
    </div>
    <!--“公文审批明细”-审批--2同意 3拒绝-->
    <div v-if="detailType === 'approval' && detail.JudgeCanOperation"
         class="proval-con">
      <div class="left">审批意见</div>
      <van-field v-model="remark"
                 type="textarea"
                 show-word-limit
                 maxlength="100"
                 placeholder="请输入审批意见" />
    </div>
    <div v-if="detailType === 'approval' && detail.JudgeCanOperation">
      <two-bottom-btn leftText="拒绝"
                      rightText="同意"
                      @cancelClick="approvalFun(3)"
                      @confirmClick="approvalFun(2)"></two-bottom-btn>
    </div>
    <!--“公文记录明细”-操作按钮-->
    <div v-if="detailType === 'record'">
      <!--审批通过且未归档显示“归档”-->
      <single-bottom-btn v-if="detail.Status === 2 && !detail.IsArchive"
                         @clickBtn="fileFun">归档</single-bottom-btn>
      <!--已归档展示销毁按钮-->
      <single-bottom-btn v-if="detail.IsArchive"
                         @clickBtn="destructionFun">销毁</single-bottom-btn>
    </div>
  </div>
</template>
<script>
import ApprovalFlow from "../../../../components/workFlow/ApprovalFlow"//审批流展示
import SingleBottomBtn from "../../../../components/SingleBottomBtn"
import TwoBottomBtn from "../../../../components/TwoBottomBtn"

export default {
  props: {
  },
  name: 'OfficeDetail',
  components: {
    ApprovalFlow,
    SingleBottomBtn,
    TwoBottomBtn
  },
  data () {
    return {
      imgUrl: this.xyMApi + '/base',
      id: 0,
      detailType: '',//当前明细类型：record记录 file归档 approval审批 copy抄送
      detail: {},
      remark: '',//审批意见（审批明细）

      //（使用审批流组件需添加）
      approvalData: {
        ApprovalFlowNodeID: undefined //当前审批节点的id
      },
    }
  },
  created () {
    if (this.$route.query.fromMessage) {
      // 从消息页面跳转
      this.id = JSON.parse(this.$store.state.messageInfo).BusinessID;
      console.log(JSON.parse(this.$store.state.messageInfo))
    } else {
      // 从列表跳转
      this.id = this.$route.query.id;
      this.detailType = this.$route.query.type;
    }
    this.getDetail();
  },
  mounted () {
  },
  methods: {
    //获取明细
    async getDetail () {
      this.xy.loading();
      let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/OfficialDocument/GetByID`, {
        ID: this.id
      })
      if (res.success) {
        this.detail = res.data;
        console.log(this.detail)
        //从消息跳转进来时设置detailType
        if (this.$route.query.fromMessage) {
          //接收人===发起公文的人
          if (JSON.parse(this.$store.state.messageInfo).ReceiverName === this.detail.FullName) {
            //审批人审批后通知发起人
            this.detailType = 'record';
          } else {
            //审批人收到需要审批的公文消息、发起人收回公文通知审批人和(已经审批通过的节点上的)抄送人
            //（抄送人只会收到已收回的消息，此时JudgeCanOperation字段为false），所以设置为approval不会在copy的时候错误展示出审批功能。（file不发消息不考虑）
            this.detailType = 'approval';
          }
        }
        this.format(this.detail.ApprovalFlow, "当前审批节点");//（使用审批流组件需添加）
        this.xy.unloading();
      } else {
        this.$toast.fail(res.msg);
        this.xy.unloading();
      }
    },

    //公文审批明细-审批 2同意 3拒绝
    async approvalFun (type) {
      let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/OfficialDocument/SaveApprovalBranchStatus`, {
        ApprovalFlowID: this.detail.ApprovalFlowID,
        ApprovalFlowNodeID: this.approvalData.ApprovalFlowNodeID,
        Option: this.remark,
        Status: type,
        OfficialDocID: this.id,
      })
      if (res.success) {
        this.xy.msgSuc('审批成功');
        //返回到列表
        this.$router.go(-1);
      }
    },

    //公文记录明细-归档
    fileFun () {
      this.xy.confirm('归档', '您确定要归档此公文吗？', this.file);
    },
    async file () {
      let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/OfficialDocument/Archive?id=${this.id}`)
      if (res.success) {
        this.xy.msgSuc('归档成功');
        //返回到列表
        this.$router.go(-1);
      }
    },

    //公文记录明细-销毁
    destructionFun () {
      this.xy.confirm('销毁', '您确定要销毁此公文吗？', this.destruction)
    },
    async destruction () {
      let res = await this.xyapi.post(`${this.$store.state.apiPath}/api/OfficialDocument/Delete?id=${this.id}`)
      if (res.success) {
        this.xy.msgSuc('销毁成功');
        //返回到列表
        this.$router.go(-1);
      }
    },

    //当前审批节点获取（使用审批流组件需添加）
    format (data) {
      let _this = this;
      var lastPass_node = 0 // 临时记载：当前遍历中，最后通过审批的节点索引下标；其中，第0个为发起人，即尚未有审批
      data.currentAuditNodeIndex = -1 // 当前待审批节点的下标
      data.map((element, index) => {
        //console.log(element);
        // 缩略预览模式开关
        element.isOverviewMode = true
        // 缩略预览列表(不大于5个)
        element.overviewList = [] // 缩略预览列表(不大于5个)
        element.isFinished = false // 该节点是否审批结束，原因见上
        element.currentAuditNode = false // 该节点是否为当前待审核节点
        // 若该审批项目结束，缩略列表显示最后审批结果的时间与状态
        element.lastComplete_time = undefined
        element.lastComplete_status = undefined
        if (element.IsComplete) {
          // 该节点已经通过了审批，相当于 element.Status === '已通过'
          lastPass_node = index
          element.isFinished = true
        } else if (element.Status === '已拒绝') {
          element.isFinished = true
        } else if (element.Status === '待审批') {
          // 判断是否为当前节点
          if (lastPass_node + 1 === index) {
            // 该节点为当前待审核节点
            element.currentAuditNode = true
            data.currentAuditNodeIndex = index
          }
        }

        var lastTime_member = undefined // 暂存：最近的一次时间点
        element.ApprovalMemberList.forEach(function (memberItem, memberIndex) {
          // 缩略图列表仅显示前4个，其余显示省略号；若共5人，则不显示省略号，直接全部显示
          if (memberIndex < 4 || element.ApprovalMemberList.length === 5) {
            element.overviewList.push(memberItem)
          }
          // 若该节点完成，显示时间、结果
          if (element.isFinished && memberItem.Status !== '待审批') {
            if (element.ApprovalFlowNodeName === '或签') {
              // 记录唯一一次审批时间
              element.lastComplete_time = memberItem.ApprovalDate;
              element.lastComplete_status = memberItem.Status;
            } else if (element.ApprovalFlowNodeName === '会签') {
              // 记录最后一次会签时间
              if (lastTime_member === undefined) {
                // 记载首次审批的时间
                lastTime_member = memberItem.ApprovalDate
              } else {
                var lastTime = new Date(lastTime_member)
                var thisTime = new Date(memberItem.ApprovalDate)
                if (thisTime > lastTime) {
                  element.lastComplete_time = memberItem.ApprovalDate;
                  element.lastComplete_status = memberItem.Status;
                }
              }
            }
          }
          if (!element.isFinished) {
            // 获取当前需审批的节点：第一个非完成节点
            if (
              _this.approvalData.ApprovalFlowNodeID === undefined &&
              element.ApprovalFlowNodeName !== '发起人'
            ) {
              console.log(element)
              _this.approvalData.ApprovalFlowNodeID = element.ApprovalFlowNodeID;
            }
          }
        })
        // 抄送列表，大致逻辑同上
        element.isOverviewMode_CC = true
        element.overviewList_CC = []
        element.ApprovalCCMemberList.forEach(function (CCItem, CCIndex) {
          // 缩略图列表仅显示前4个，其余显示省略号；若共5人，则不显示省略号，直接全部显示
          if (CCIndex < 4 || element.ApprovalCCMemberList.length === 5) {
            element.overviewList_CC.push(CCItem)
          }
        })
      });
    }

  }
}
</script>
<style lang="less" scoped>
.official-detail {
  padding: 40px 40px 110px;
  background: #fff;
  .title {
    font-size: 36px;
    padding-bottom: 40px;
    border-bottom: 1px solid #eaeaea;
    display: flex;
    .name-left {
      width: 92px;
      height: 92px;
      line-height: 92px;
      text-align: center;
      border-radius: 50%;
      color: #ffffff;
      background: #2980fe;
      margin-right: 25px;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        border-radius: 50%;
        > img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
    .name-right {
      color: #161616;
      font-weight: bold;
      flex: 1;
      > div:first-child {
        margin: 5px 0;
      }
      .status {
        color: #606060;
        font-size: 28px;
        font-weight: normal;
      }
    }
    .officeStatus {
      right: 0;
      top: -26px;
      width: 216px;
      height: 220px;
      img {
        width: 100%;
      }
    }
  }
  .item {
    display: flex;
    align-items: flex-start;
    font-size: 28px;
    line-height: 35px;
    margin: 30px 0;
    .left {
      color: #606060;
      width: 115px;
      text-align: right;
      margin-right: 20px;
    }
    .right {
      color: #161616;
      flex: 1;
      word-break: break-all;
      word-wrap: break-word;
      white-space: pre-wrap;
    }
  }
  .proval-process {
    padding-top: 40px;
    border-top: 1px solid #eaeaea;
    .left {
      color: #606060;
      width: 115px;
      text-align: right;
      margin-bottom: 30px;
    }
  }
  .proval-con {
    margin-bottom: 40px;
    .left {
      color: #606060;
      width: 115px;
      text-align: right;
      margin-bottom: 30px;
    }
    .van-cell {
      border: 1px solid #dbdbdb;
      border-radius: 8px;
    }
  }
}
</style>
